import React from "react";
import "./ScheduleTable.css";
import { showDate } from "../../../../utils/dateUtils";
import { useMatchesStore } from "../../../../store/matchesStore";
import { Button } from "../../../catalyst/button";

interface ScheduleTableProps {
  data: any[];
  onMatchSetup?: (entry: any) => void;
}

export const ScheduleTable: React.FC<ScheduleTableProps> = ({
  data,
  onMatchSetup,
}) => {
  const { allMatches } = useMatchesStore();

  return (
    <div className="table-container">
      <table className="schedule-table">
        <thead>
          <tr>
            <th>S.No.</th>
            <th>Stage</th>
            <th>Date</th>
            <th>Format</th>
            <th>Venue</th>
            <th>Tee Off</th>
          </tr>
        </thead>
        <tbody>
          {data.map((entry) => (
            <tr
              key={entry.id}
              className={`
                ${entry.isFinals ? "finals-row" : ""}
                ${entry.groupOrKnockout === "Knock-out" ? "knockout-row" : ""}
              `}
            >
              <td className="text-center">{entry.order}</td>
              {entry.isFirstInStage ? (
                <td className="stage-cell" rowSpan={entry.stageRowspan}>
                  {entry.groupOrKnockout}
                </td>
              ) : null}
              <td>{showDate(entry.date)}</td>
              <td>{entry.matchType}</td>
              <td>{entry.location}</td>
              <td className="tee-off-cell">
                <div className="flex items-center justify-between">
                  {entry.teeOff}
                  {onMatchSetup && allMatches && allMatches.map((match) => {
                    if (
                      match.matchId === entry.id &&
                      match.allowPlayerSelections
                    ) {
                      return (
                        <Button
                          key={entry.id}
                          color="emerald"
                          onClick={() => onMatchSetup(entry)}
                        >
                          Setup Players
                        </Button>
                      );
                    }
                  })}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
